import FundSelectionComponent from './FundSelectionContainer';

export default FundSelectionComponent;
